import Vue from 'vue'
import axios from 'axios';

//sistema

Vue.prototype.$listarPermissoes = async () => {
  try {
    let res = await axios.get('permissao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

// get permissao/{id}/user

Vue.prototype.$suaPermissao = async (id) => {
  try {
    let res = await axios.get('permissao/'+id+'/user', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}


Vue.prototype.$permissaoCadastro = async (permissao) =>{
  try { 
    let res = await axios.post('permissao',{
        nome: permissao.nome,
        tipo: permissao.tipo,
        hab_manifestacao: permissao.h.manifesto,
        hab_cidadao: permissao.h.cidadao,
        hab_mod_departamento: permissao.h.mod_departamento,
        hab_log: permissao.h.log,
        hab_departamentos: permissao.departamentos,
        //status: permissao.status, 
    });
   return res.data;
  } catch (e) {
    //console.log(e.message);
    throw e;
  } 
}

Vue.prototype.$permissaoMudarStatus = async (permissao,id) =>{
  try { 
    let res = await axios.put('permissao/'+id,{
        status: permissao.status, 
    });
   return res.data;
  } catch (e) {
    throw e;
  } 
}

Vue.prototype.$permissaoEditar = async (permissao,id) =>{
  try { 
    //console.log(cidadao);
    let res = await axios.put('permissao/'+id,{
      nome: permissao.nome,
      tipo: permissao.tipo,
      hab_manifestacao: permissao.h.manifesto,
      hab_cidadao: permissao.h.cidadao,
      hab_mod_departamento: permissao.h.mod_departamento,
      hab_log: permissao.h.log,
      hab_departamentos: permissao.departamentos,
    });
  return res.data;
  } catch (e) {
    throw e;
  } 
}

Vue.prototype.$permissaoDelete = async (id) => {
  try {
    let res = await axios.delete('permissao/'+id, {
    });
    return res.data;
  } catch (e) {
    throw e;
  }
}